import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { NGX_MAT_DATE_FORMATS, NgxMatDateAdapter, NgxMatDateFormats } from '@angular-material-components/datetime-picker';

import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS
} from '@angular/material-moment-adapter';
import * as moment from 'moment';
import { CustomNgxDatetimeAdapter } from './CustomNgxDatetimeAdapter';
//create our constant variable with the information about the format that we want
const CUSTOM_DATE_FORMATS: NgxMatDateFormats = {
  parse: {
    dateInput: 'lll'
  },
  display: {
    dateInput: 'lll',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  }
};

@Component({
  selector: 'app-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.css'],
  providers: [

    {
      provide: NgxMatDateAdapter,
      useClass: CustomNgxDatetimeAdapter,
      deps: [MAT_DATE_LOCALE, NGX_MAT_DATE_FORMATS]
    },
    { provide: NGX_MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-in' },
  ],
})
export class DateTimePickerComponent implements OnInit, OnDestroy {

  @Input() placeholder;
  @Input() type;
  @Input() value;
  @Input() id;
  @Input() style;
  @Input() class;
  @Input() label;
  @Input() hint;
  @Input() control_type;
  @Input() required;
  @Input() error_msg;
  @Input() form: UntypedFormGroup;
  @Input() controlName;
  @Output() getValue = new EventEmitter();
  @Output() onChange = new EventEmitter();
  @Input() field;
  @Input() minValue;
  @Input() maxValue;
  @Input() disabled;
  subscription: Subscription;
  prev_value;
  @Input() verified_status;
  @Input() notes;
  @Input() reason;
  @Input() verification_required;
  @Input() appearance;

  date = new UntypedFormControl();

  picker_open_flag = 1;
  @ViewChild('picker') picker;
  random_id = 'date_time_picker' + Math.floor((Math.random() * 10000) + 1) + Date.now();

  constructor(private adapter: DateAdapter<any>) { }

  ngOnInit() {

    this.adapter.setLocale('en-in')
    if (this.form.get(this.controlName).value) {
      if (this.form.get(this.controlName).value) {
        this.date.setValue(new Date(this.form.get(this.controlName).value));
      }
    }

    this.subscription = this.form.get(this.controlName).valueChanges.subscribe(res => {
      if (res && res != this.prev_value) {
        this.prev_value = res;
        this.date.setValue(new Date(this.form.get(this.controlName).value));
        this.onChange.emit({ value: moment.parseZone(this.form.get(this.controlName).value).format('YYYY-MM-DD[T]HH:mm:ss') });
      }
      if (!res) {
        this.date.reset()
      }
    })
  }

  ngOnDestroy(): void {
    if (this.subscription && this.subscription.unsubscribe) {
      this.subscription.unsubscribe();
    }

  }

  addEvent(ev) {
    this.form.get(this.controlName).setValue(moment.parseZone(ev.value).format('YYYY-MM-DD[T]HH:mm:ss'));
    this.getValue.emit(ev);
    this.onChange.emit({ value: moment.parseZone(ev.value).format('YYYY-MM-DD[T]HH:mm:ss') });
  }
  anc(evt) {

  }
  removeDate(ev) {
    ev.preventDefault();

    this.form.get(this.controlName).reset();
    this.date.reset();
  }

  openPicker(open_flag) {
    if (open_flag && !this.disabled) {
      setTimeout(() => {
        this.picker.open();
      })
    }
  }
}
